export default function AUC_ROC_Curve() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">AUC_-_ROC_Curve</h1>
      <p>Content for AUC_-_ROC_Curve goes here.</p>
    </div>
  );
}
